export const ISSFacts = () => (
  <div className="glass-card p-6">
    <h2 className="section-title mb-4">ISS Facts</h2>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-white/5 rounded-xl p-4 text-center">
        <p className="text-2xl font-mono font-bold text-cosmic-blue">17,500</p>
        <p className="text-xs text-slate-500 uppercase tracking-wider mt-1">MPH Speed</p>
      </div>
      <div className="bg-white/5 rounded-xl p-4 text-center">
        <p className="text-2xl font-mono font-bold text-space-gold">254</p>
        <p className="text-xs text-slate-500 uppercase tracking-wider mt-1">Miles Altitude</p>
      </div>
      <div className="bg-white/5 rounded-xl p-4 text-center">
        <p className="text-2xl font-mono font-bold text-ignition-red">16</p>
        <p className="text-xs text-slate-500 uppercase tracking-wider mt-1">Orbits/Day</p>
      </div>
      <div className="bg-white/5 rounded-xl p-4 text-center">
        <p className="text-2xl font-mono font-bold text-emerald-400">92</p>
        <p className="text-xs text-slate-500 uppercase tracking-wider mt-1">Min per Orbit</p>
      </div>
    </div>
  </div>
);
